/*globals $, siteRoot, ajaxUrl, console */

$(document).ready(function () {
    "use strict";

    $("#updateAccountModal").on("show.bs.modal", function () {
        User.toggleAccountEditor($(this));
    });
    
    $("#wp-submit").on("click", function (e) {
        sendGAEvent($(e.target), "BFF Login", "BFF Flow");
        $(e.target).addClass("btn-loading");
    });
    
    $("#wp-register").on("click", function (e) {
        sendGAEvent($(e.target), "New BFF Registration", "BFF Flow");
    });
    
    $("[data-opt-in]").on("click", function (e) {
        User.optIn(e, true);
    });
    
    $("[data-opt-out]").on("click", function (e) {
        User.optIn(e, false);
    });
});

var User = {

    loginForm: $("#loginform"),
    loginPasswordInput: $("#loginPass"),
    
    showPasswordInput: function () {
        "use strict";

        this.loginForm.addClass("user-exists");
        this.loginPasswordInput.focus();
    },
    
    hidePasswordInput: function () {
        "use strict";

        this.loginForm.removeClass("user-exists");
    },
    
    toggleAccountEditor: function (target) {
        "use strict";

        var accountPage = $("#pageAccount"),
            accountInfoBlock = accountPage.find("[account-block=\"info\"]"),
            accountEditorBlock = accountPage.find("[account-block=\"editor\"]"),
            toggleAttr = "data-editor",
            toggle = target.attr(toggleAttr);

        $("#registerEmail").attr("readonly", "true");
        $("#registerPassword").attr("readonly", "true");
        $("#registerPassword").attr("disabled", "disabled");
//        $("#registerType").val("update");
//        $("#registerType2").val("update");
        $("#wp-submit").val("Update Info");
    },

    optIn: function (event, toggle) {
        "use strict";
        event.preventDefault();

        var target = $(event.target),
            dataSet = {
                "action": "optin_user",
                "optin": toggle
            };

        if (toggle) {
            dataSet["type"] = target.data("opt-in");

            var apiRequest = $.ajax({
                type: "post",
                url: ajaxUrl,
                data: dataSet
            });

            apiRequest.done(function (response) {
                // console.log(response);
                location.reload();
            });

            apiRequest.fail(function (response) {
                console.log(response);
            });
        } else {
            dataSet["type"] = target.data("opt-out");
            target.parent().remove();
        }
    }
};